import { render, staticRenderFns } from "./activity-statistics.vue?vue&type=template&id=7e8f1772&scoped=true&"
import script from "./activity-statistics.vue?vue&type=script&lang=js&"
export * from "./activity-statistics.vue?vue&type=script&lang=js&"
import style0 from "./activity-statistics.vue?vue&type=style&index=0&id=7e8f1772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8f1772",
  null
  
)

export default component.exports